import { mapGetters } from 'vuex'
import i18n from 'services/i18n'
import { is } from 'core-js/core/object'

export const heroDataHelper = {
    computed: {
        ...mapGetters({
            packageInfo: 'User/getPackageInfo',
            isReportingAllowed: 'User/getIsReportingAllowed',
            currentLanguage: 'Languages/getSelectedCountryCode',
            isLoggedIn: 'isLoggedIn'
        }),
        isFiChatBotPackage () {
            return this.packageInfo.some(el => el.code === 'fi-chatbot' || el.code === 'fi-chatbot-trial')
        },
        slidesNumber () {
            return 3
        },
        slides () {
            switch (this.$totemLang) {
            case 'fi':
                return {
                    background: [],
                    videoSrc: '',
                    introType: ['image', 'image', 'image'],
                    buttonLink: [
                        {
                            name: 'all-content',
                            params: { packageSlug: 'fi-tekoaly' }
                        },
                        {
                            name: 'all-packages-virtual-classrooms',
                        },
                        { path: '/palvelu/kaikki-koulutusaiheet/etakoulutukset' },
                    ],
                    secondaryButtonLink: []
                }
            case 'se':
                return {
                    background: [],
                    videoSrc: 'https://player.vimeo.com/video/897131387',
                    introType: ['image', 'image', 'video'],
                    buttonLink: [
                        {
                            name: 'all-content',
                            params: { packageSlug: 'se-ai' }
                        },
                        { name: '' },
                        { name: 'all-packages-learning-paths' }
                    ],
                    secondaryButtonLink: [
                        {
                            name: 'course-list-course-page',
                            params: { packageSlug: 'se-ai', courseSlug: '6206237-ai-de-forsta-stegen' }
                        }
                    ]
                }
            case 'no':
                return {
                    background: [],
                    videoSrc: '',
                    introType: ['image', 'image', 'image'],
                    buttonLink: [
                        { name: 'all-content', params: { packageSlug: 'no-ki' } },
                        { name: '' },
                        { name: '' },
                    ],
                    secondaryButtonLink: []
                }
            }
        }
    },
    methods: {
        openVideoModal () {
            this.$modal.show('hero-video-modal')
        },
        translationExist (translation) {
            return i18n.te(translation)
        }
    }
}
